var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
/**
 * [CLAIMS_CONTEXT]
 * purpose: Displays and persists leakage-cause-fixed choices for water damage qualification.
 * touches: declaration qualification flow, insurer/self-care settings override
 * invariants: choices must map to LeakageCauseFixed values and translated keys
 * inputs: selfCareSettings declaration page overrides, default leakage constants
 * outputs: updates qualification.isWaterLeakageCauseFixed via store action
 * see: frontend/src/shared/constants/waterDamageConstants.ts, frontend/src/shared/insurer.ts, frontend/src/declaration/store/qualification.ts
 */
import Component from 'vue-class-component';
import { namespace } from 'vuex-class';
import { QuestionComponent, QuestionProps } from '@declaration/question';
import { LeakageCauseFixed } from '@shared/types/api/claim';
import RadioPrimaryButton from '@declaration/components/UI/RadioPrimaryButton.vue';
import QuestionPanel from '@declaration/components/UI/QuestionPanel.vue';
import { objectToTranslatableChoices, } from '@shared/choice';
import { LEAKAGE_CAUSE_FIXED_TRAD_KEYS } from '@shared/constants/waterDamageConstants';
import { InsurerFeatureFlag, insurerHasFeature } from '@shared/featureFlags/insurerFeatureFlags';
const claim = namespace('claim');
const qualification = namespace('qualification');
const settings = namespace('settings');
let WaterLeakageCauseFixedQuestion = class WaterLeakageCauseFixedQuestion extends QuestionComponent {
    constructor() {
        super(...arguments);
        this.yesNoQuestionValuesAndTradKeys = [];
    }
    created() {
        var _a, _b, _c, _d;
        const settingsChoices = (_d = (_c = (_b = (_a = this.selfCareSettings) === null || _a === void 0 ? void 0 : _a.declaration) === null || _b === void 0 ? void 0 : _b.pages) === null || _c === void 0 ? void 0 : _c.waterLeakageCauseFixed) === null || _d === void 0 ? void 0 : _d.choices;
        const allowedChoices = this.getAllowedChoicesFromSettings(settingsChoices);
        if (allowedChoices.length > 0) {
            this.yesNoQuestionValuesAndTradKeys = objectToTranslatableChoices(this.filterTradKeysByAllowedValues(allowedChoices));
            return;
        }
        this.yesNoQuestionValuesAndTradKeys = objectToTranslatableChoices(LEAKAGE_CAUSE_FIXED_TRAD_KEYS);
    }
    get selfCareSettings() {
        return this.setting('selfCareSettings');
    }
    getAllowedChoicesFromSettings(choices) {
        if (!(choices === null || choices === void 0 ? void 0 : choices.length)) {
            return [];
        }
        const allowedValues = new Set(Object.values(LeakageCauseFixed));
        return choices.filter((choice) => allowedValues.has(choice));
    }
    filterTradKeysByAllowedValues(allowedValues) {
        return allowedValues.reduce((acc, key) => {
            const value = LEAKAGE_CAUSE_FIXED_TRAD_KEYS[key];
            if (typeof value === 'string') {
                acc[key] = value;
            }
            return acc;
        }, {});
    }
    updateClaim(isWaterLeakageCauseFixed) {
        this.updateAndSaveWaterDamageQualification({
            qualificationPayload: {
                isWaterLeakageCauseFixed,
            },
            step: this.step,
        });
    }
    get panelTitle() {
        return this.$tc('claim.qualification.repair.title');
    }
    get sidebarTitle() {
        const key = 'claim.qualification.repair.sidebar_title';
        return this.$te(key) ? this.$tc(key) : this.panelTitle;
    }
    get answer() {
        switch (this.waterDamageQualification.isWaterLeakageCauseFixed) {
            case LeakageCauseFixed.YES:
                return this.$tc('claim.qualification.repair.sumup.yes');
            case LeakageCauseFixed.NO:
                return this.$tc('claim.qualification.repair.sumup.no');
            case LeakageCauseFixed.IN_PROGRESS:
                return this.$tc('claim.qualification.repair.sumup.repair-in-progress');
            default:
                return null;
        }
    }
    get hideHelpLink() {
        return insurerHasFeature(InsurerFeatureFlag.HideHelpLink);
    }
    get showHelpLink() {
        var _a, _b, _c, _d;
        if (this.hideHelpLink &&
            ((_d = (_c = (_b = (_a = this.selfCareSettings) === null || _a === void 0 ? void 0 : _a.declaration) === null || _b === void 0 ? void 0 : _b.pages) === null || _c === void 0 ? void 0 : _c.waterLeakageCauseFixed) === null || _d === void 0 ? void 0 : _d.showHelpLink) === false) {
            return false;
        }
        return true;
    }
};
__decorate([
    claim.State('isUpdatingClaim')
], WaterLeakageCauseFixedQuestion.prototype, "isUpdatingClaim", void 0);
__decorate([
    qualification.State('qualification')
], WaterLeakageCauseFixedQuestion.prototype, "waterDamageQualification", void 0);
__decorate([
    qualification.Action('updateAndSaveQualification')
], WaterLeakageCauseFixedQuestion.prototype, "updateAndSaveWaterDamageQualification", void 0);
__decorate([
    settings.Getter('setting')
], WaterLeakageCauseFixedQuestion.prototype, "setting", void 0);
WaterLeakageCauseFixedQuestion = __decorate([
    Component({
        components: { RadioPrimaryButton, QuestionPanel },
        props: QuestionProps,
    })
], WaterLeakageCauseFixedQuestion);
export default WaterLeakageCauseFixedQuestion;
